import { FETCH_ALL, CREATE, UPDATE, DELETE, LIKE } from '../constants/actionTypes';
import {toast} from 'react-toastify';
import * as api from '../api/index.js';

export const getPosts = () => async (dispatch) => {
  try {
    const { data } = await api.fetchPosts();
    dispatch({ type: FETCH_ALL, payload: data });
  } catch (error) {
    toast.error(error.message)
  }
};

export const createPost = (post) => async (dispatch) => {
  try {
    const { data } = await api.createPost(post);
    toast.success('Success create!')
    dispatch({ type: CREATE, payload: data });
  } catch (error) {
    toast.error(error.message)
  }
};

export const updatePost = (id, post) => async (dispatch) => {
  try {
    const { data } = await api.updatePost(id, post);
    toast.info('Updated!')
    dispatch({ type: UPDATE, payload: data });
  } catch (error) {
    toast.error(error.message)
  }
};

export const likePost = (id) => async (dispatch) => {
  try {
    const { data } = await api.likePost(id);
    dispatch({ type: LIKE, payload: data });
    toast.success('Like was added!')
  } catch (error) {
    toast.error(error.message)
  }
};

export const deletePost = (id) => async (dispatch) => {
  try {
    await await api.deletePost(id);
    toast.warn('This item was deleted.')
    dispatch({ type: DELETE, payload: id });
  } catch (error) {
    toast.error(error.message)
  }
};
